import { render, staticRenderFns } from "./FichasDePartidosListView.vue?vue&type=template&id=39f9a036&scoped=true&"
import script from "./FichasDePartidosListView.vue?vue&type=script&lang=js&"
export * from "./FichasDePartidosListView.vue?vue&type=script&lang=js&"
import style0 from "./FichasDePartidosListView.vue?vue&type=style&index=0&id=39f9a036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9a036",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VContent,
  VFlex,
  VIcon,
  VProgressCircular,
})
